import { useEffect, useState } from "react";
import { Typography } from "../../../../../core/components/molecules/Typography";
import { practiceConfigStore } from "../../../stores/practiceConfigStore";
import { SectionContainer } from "../../../components/SectionContainer";
import CustomRadio from "../../../components/LabelFlexRadio";
import CronometerInput from "../../../../../core/components/molecules/CronometerInput";

export function ReadySection() {
  const { setCronometer, setHasCronometer, cronometer } = practiceConfigStore()

  const [hasTimer, setHasTimer] = useState<string>('no-timer');

  useEffect(() => {
    if(hasTimer === 'no-timer') {
      setCronometer("");
    }
  }, [hasTimer])

  return (
    <SectionContainer 
      title="Para começar o simulado defina"
      warning="O simulado não será encerrado se você atingir o tempo de prova estabelecido. Você será notificado e poderá continuar realizando o simulado."
    >
      <div className="flex flex-col gap-xl">
        <CustomRadio 
          value="no-timer"
          checked={hasTimer}
          setData={(value) => { 
            setHasTimer(value);
            setHasCronometer(false);
            setCronometer("");
          }}
        >
          <Typography>
            Fazer a prova sem cronômetro
          </Typography>
        </CustomRadio>
        <CustomRadio 
          value="with-timer"
          checked={hasTimer}
          setData={(value) => { 
            setHasCronometer(true)
            setHasTimer(value) 
          }}
        >
          <div className="flex xs:flex-col lg:flex-row gap-sm xs:items-start lg:items-center">
            <Typography>
              Definir tempo do simulado, em horas e minutos
            </Typography>
            <CronometerInput 
              setData={setCronometer} 
              data={cronometer} 
              disabled={hasTimer === 'no-timer'}
            />
          </div>
        </CustomRadio>
      </div>
    </SectionContainer>
  )
}